// extracted by mini-css-extract-plugin
export var container = "dx_c";
export var fadeDiv = "dx_f4";
export var placeholderWrapper = "dx_q4";
export var video = "dx_q5";
export var videoWrapper = "dx_jd";
export var vimeoPlayer = "dx_q6";
export var wrapper = "dx_B";